<template>
  <!-- 展览列表 -->
  <div class="page-volunteer" :class="{'mobile':$vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
    <div class="page-volunteer-wrap g-container" :class="{'mobile': $vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
      <div class="g-banner">
        <img src="~@images/banner_volunteer.jpg" alt="">
      </div>

      <div class="content pa-4 pa-md-0 g-wrap">
        <v-layout wrap>
          <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" :subHeight="'760px'" @eventTabClick="eventTabClick"></cmpTab>

          <!-- 藏品征集、社会捐赠 -->
          <v-flex class="g-tab-list py-md-12" xs12 sm12 md11>
            <div class="g-detail-html pa-md-8" v-html="currentData.content"></div>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
  import '@css/mobile/volunteer/index.scss';

  import cmpTab from '@cmp/tab'
  export default {
    components: { cmpTab },
    data() {
      return {
        activeVal: '1',
        tabList: [],
        currentData: {},
        type:this.$route.query.type || '1', 
      }
    },
    methods: {
      goDetail(item) {
        this.$router.push('/collect/detail?id=' + item.id)
      },
      eventTabClick(val, index) {
        this.currentData = this.tabList[index]
      },
      // 镇馆之宝
      getData() {
        this.$http
          .get('/common/article', {
            category: 'zyz'
          })
          .then(res => {
            if (res.success) {
              if(res.data.length) {
                res.data.forEach(item => {
                  item.val = item.id
                  item.name = item.title
                })
                this.tabList = res.data

                if(this.type == '2'){
                  this.currentData = res.data[1]
                this.activeVal = res.data[1].val
                }else{
                  this.currentData = res.data[0]
                this.activeVal = res.data[0].val
                }
              }
            } else {
              this.$notify(res.message)
            }
          })
      }
    },
    created() {
      this.getData()
    }
  }
</script>

<style lang="scss" scoped>
.page-volunteer-wrap {
  &.pc {
    .banner {
      img {
        width: 100%;
        height: 480px;
        margin: 0 auto;
        display: block;
      }
    }

    .content {
      .g-detail-html {
        background: #fff;
      }
    }
  }
  .content {
    
  }
}
</style>